import { render, staticRenderFns } from "./End.vue?vue&type=template&id=670ecb72&scoped=true&"
import script from "./End.vue?vue&type=script&lang=js&"
export * from "./End.vue?vue&type=script&lang=js&"
import style0 from "./End.vue?vue&type=style&index=0&id=670ecb72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670ecb72",
  null
  
)

export default component.exports